import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const WebMobile = () => (
  <motion.div className="industry-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    <div className="industry-content">
      <h1>Web & Mobile Applications</h1>
      <p>Responsive, high-performance apps tailored to your audience, built with modern stacks.</p>
      <ul className="bullet-points">
        <li>💻 React, Vue, Angular</li>
        <li>📱 Flutter, React Native</li>
        <li>🔄 RESTful & GraphQL APIs</li>
        <li>📡 Real-time & PWA features</li>
      </ul>
    </div>
  </motion.div>
);

export default WebMobile;
